var map = {
	"./decidim/avatar-multiuser.png": 92110,
	"./decidim/brands/google.svg": 47233,
	"./decidim/cc-badge.png": 75792,
	"./decidim/decidim-logo.svg": 79436,
	"./decidim/default-avatar.svg": 36948,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 99984,
	"./decidim/icons.svg": 53391,
	"./decidim/pattern.png": 76416,
	"./decidim/placeholder-card-g.svg": 96949,
	"./decidim/placeholder-card-l.svg": 81502,
	"./decidim/placeholder.jpg": 23149,
	"./decidim/remixicon.symbol.svg": 17921,
	"./decidim/vendor/leaflet/layers-2x.png": 41216,
	"./decidim/vendor/leaflet/layers.png": 95103,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 24042,
	"./decidim/vendor/leaflet/marker-icon.png": 31009,
	"./decidim/vendor/leaflet/marker-shadow.png": 56590,
	"./decidim/vendor/social-share-button/douban.svg": 48928,
	"./decidim/vendor/social-share-button/email.svg": 5661,
	"./decidim/vendor/social-share-button/facebook.svg": 26115,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 37197,
	"./decidim/vendor/social-share-button/hacker_news.svg": 29437,
	"./decidim/vendor/social-share-button/linkedin.svg": 6997,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 53734,
	"./decidim/vendor/social-share-button/pinterest.svg": 32099,
	"./decidim/vendor/social-share-button/reddit.svg": 65111,
	"./decidim/vendor/social-share-button/telegram.svg": 76666,
	"./decidim/vendor/social-share-button/tumblr.svg": 66041,
	"./decidim/vendor/social-share-button/twitter.svg": 29068,
	"./decidim/vendor/social-share-button/vkontakte.svg": 22066,
	"./decidim/vendor/social-share-button/wechat.svg": 61789,
	"./decidim/vendor/social-share-button/whatsapp.svg": 98957,
	"./decidim/vendor/social-share-button/x.svg": 85853,
	"./decidim/vendor/social-share-button/xing.svg": 35587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67955;